<template lang="pug">
  .marketing
    router-view
</template>

<script>

export default {
  data () {
    return {
    }
  },
  beforeMount () {
  },  
  computed: {
  },
  methods: {
  }
}

</script>

<style lang="stylus" scoped>

//4d27ff, 0092ff, 00e3fd, 00f9c4, ffbb2c, ff6945
body
  overflow hidden

#app
  height 100vh
  //max-height 100vh
  +for_breakpoint(mobile)
    padding 20px 0
.marketing
  align-items center
  //background linear-gradient(135deg, #4026CA 0%, #3DDEFB 100%)
  background-color #172B2C
  min-height 100vh
  display flex
  //max-height 100vh
  

</style>
